<template>
	<div class="step-question">
		<v-flex>
			<v-layout align-center>
				<v-flex xs6 lg4 ml-3 text-xs-left class="title-question">
					<p class="ma-0" v-html="question"></p>
				</v-flex>
				<v-flex text-xs-right>
					<v-btn
						class="btn-auto btn-selected"
						:class="{'active' : showOne }"
						type="button"
						@click="open('showOne', 'showTwo')"
					>
						?
					</v-btn>
				</v-flex>
			</v-layout>
			<v-layout mt-4 class="layout">
				<div
					class="triangle"
					:class="{ 'active-two' : showTwo }"
				></div>
				<v-flex xs12 class="message-box">
					<v-flex v-if="showOne">
						<v-layout row justify-space-between align-center>
							<v-flex>
								<v-layout column>
									<v-flex class="title-integration">
										<p class="ma-0" v-html="acceptTitle"></p>
									</v-flex>
									<v-flex class="description" mt-3>
										<p class="ma-0" v-html="acceptDescription"></p>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex>
								<v-flex class="video">
									<img class="img-source" :src="'/static/img/imgconta2.jpeg'" alt="img-conta">
								</v-flex>
							</v-flex>
						</v-layout>
						<v-flex mt-3>
							<v-flex xs12 mb-3 class="title-warehouse">
								Seleccionar una empresa
							</v-flex>
							<v-flex xs4>
								<HeaderSelect
									return-object
									placeholder="Seleccione una empresa"
									class="select"
									item-text="name"
									item-value="id"
									:disabled="$route.meta.noChangeCompany"
									:height="33"
									:items="getGlobalSubsidiaries"
									:value="currentSubsidiary.id"
									@input="$setCurrentSubsidiary"
								/>
							</v-flex>
						</v-flex>
					</v-flex>
					<v-flex v-if="showTwo">
						{{ negativeTitle }}
					</v-flex>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-dialog
			v-model="openDialog"
			persistent
			max-width="470"
		>
			<v-card class="dialog-contact">
				<v-btn
					class="btn-close btn-auto"
					depressed
					small
					@click="$emit('close-dialog')"
				>
					<span class="error--text">x</span>
				</v-btn>
				<v-flex mt-3 text-xs-center class="title-question">
					Para integrarte con quipu debes ir a la configuración de
				</v-flex>
			</v-card>
		</v-dialog>
		<section class="modal-filter-footer">
			<v-flex text-xs-center>
				<v-btn
					class="color-btn"
					color="btnFollowing"
					type="button"
					:disabled="disabledQuestion"
					@click.native="$emit('following-question')"
				>
					Siguiente
				</v-btn>
			</v-flex>
		</section>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

async function created() {
	const dataUserInfo = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	const params = {
		customerId: dataUserInfo ? dataUserInfo.subsidiary.customerId : null,
	};
	await this.$loadSubsidiaries({ context: this, params });
	const { subsidiaryId, subsidiaryName } = this.$route.params;
	if (subsidiaryId && subsidiaryName) {
		const id = Number(subsidiaryId);
		const currentSubsidiary = this.getGlobalSubsidiaries.find(sub => sub.id === id);
		this.$setCurrentSubsidiary(currentSubsidiary);
	} else if (this.getGlobalSubsidiaries.length === 1) {
		const currentSubsidiary = this.getGlobalSubsidiaries.find(sub => sub.companyId != null);
		this.$setCurrentSubsidiary(currentSubsidiary);
	}
}
function disabledQuestion() {
	return (this.showOne && !this.currentSubsidiary.id);
}

function open(propTrue, propFalse) {
	this[propTrue] = true;
	this[propFalse] = false;
}

function data() {
	return {
		showOne: true,
		showTwo: false,
	};
}

export default {
	name: 'step-question',
	components: {
		HeaderSelect: () => import('@/components/shared/inputs/header-select'),
	},
	computed: {
		disabledQuestion,
		...mapGetters('user', [
			'userAvatar',
			'userName',
		]),
		...mapGetters('subsidiary', [
			'currentSubsidiary',
			'getGlobalSubsidiaries',
		]),
	},
	created,
	data,
	methods: {
		open,
		...mapActions('user', {
			$clearUser: 'clearUser',
		}),
		...mapActions('subsidiary', {
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
			$loadSubsidiaries: 'loadSubsidiaries',
		}),
	},
	props: {
		acceptDescription: {
			default: 'La contabilidad es una disciplina que se encarga de estudiar, medir y analizar el patrimonio y la situación económica financiera de una empresa u organización, con el fin de facilitar la toma de decisiones en el seno de la misma y el control externo, presentando la información, previamente registrada, de manera sistemática y útil para las distintas partes interesadas.',
			type: String,
		},
		acceptTitle: {
			default: 'INTEGRATE CON MAKIPOS',
			type: String,
		},
		negativeTitle: {
			default: 'YO LLEVO MI CONTABILIDAD',
			type: String,
		},
		openDialog: {
			default: false,
			type: Boolean,
		},
		question: {
			default: 'BIENVENIDO AL SISTEMA CONTABLE<br/>MAKIPOS!',
			type: String,
		},
		subsidiaryId: [Number, String],
		validIntegration: {
			default: true,
			type: Boolean,
		},
	},
};
</script>

<style lang="scss" scoped>
	.step-question {
		padding: 10px 125px 80px;
		@media (max-width: 768px) {
			padding: 30px 0px 120px;
			width: auto;
		}
	}

	.title-question {
		color: #02979b !important;
		font-family: font(open-bold);
		font-size: 16px;
	}

	.color-btn {
		color: #02979b !important;
		font-family: font(open-bold) !important;
		background-color: PowderBlue !important;
		font-size: 14px !important;
		height: 40px !important;
		width: 130px !important;
	}

	.btn-selected {
		border: 1px solid color(primary);
		border-radius: 100%;
		box-shadow: none !important;
		color: #02979b !important;
		font-family: font(open-semibold);
		font-size: 18px;
		height: 64px !important;
		width: 64px !important;

		&.active {
			background-color: #02979b !important;
			box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15) !important;
			color: color(white) !important;
			font-family: font(open-bold);
			letter-spacing: 0px;
		}
	}

	.message-box {
		background-color: color(white);
  		box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.07);
		border-radius: 20px;
		border: PowderBlue 5px solid;
		font-family: font(open-bold);
		position: relative;
    	width: 100%;
		padding: 30px 39px;
	}

	.triangle {
		border-bottom: 26px solid rgba(0, 0, 0, 0.05);
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		position: absolute;
		right: 117px;
		top: -26px;
		z-index: 1;

		&:before {
			border-bottom: 25px solid color(white);
			border-left: 7px solid transparent;
			border-right: 7px solid transparent;
			bottom: -26px;
			content: '';
			left: -7px;
			position: absolute;
		}

		&.active-two {
			right: 32px;
		}
	}
	.select {
		max-width: 250px;
	}

	.layout {
		position: relative;
	}

	.title-integration {
		color: #494949;
		font-family: font(open-bold);
		font-size: 16px;
	}

	.description {
		color: #909090;
		font-family: font(open-regular);
		font-size: 12px;
		width: 390px;
	}

	.video {
		// background-color: #f2f6f7;
		height: 202px;
		position: relative;
		overflow: hidden;
	}
	.video::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 70px;
		background: linear-gradient(to top, rgba(255, 255, 255, 0.9), transparent);
		pointer-events: none;
	}

	.img-source {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.title-warehouse {
		border-bottom: 1px solid #d2d2d2;
		color: #494949;
		font-family: font(open-bold);
		font-size: 16px;
		padding-bottom: 9px;
	}

	.dialog-contact {
		border-radius: 11px;
		box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.13);
		padding: 35px 55px 60px 55px;
	}

	.btn-contact {
		background-color: #4caf50;
		border-radius: 5px;
		color: white;
		font-family: map-get($fonts, open-bold);
		font-size: 14px;
		padding: 9px;
	}

	.btn-close {
		background-color: transparent !important;
		position: absolute !important;
		right: 10px;
		top: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/accountant/step-question.vue